<template>
	<div class="flex gap-3 md:items-center relative">



		<FilterGroupedStatus  v-if="!props.collectionModeData?.hideHeaderFilters" v-model="filters.allStatuses"  @change="triggerSearch" />

		<div v-if="!props.collectionModeData?.hideHeaderSearch" class="flex gap-3 md:items-center relative">
			<EwInput class="w-full" variant="transparent" v-model="filters.search" :loading="true"
				:placeholder="labels.searchPlaceholder" type="search" @keyup.enter="triggerSearch" size="md">
				<!-- <template #prepend>
					<div class="ew-input-group-text px-0">
						<EwButton type="secondary" variant="soft" class="!rounded-r-0" size="md" :icon="toggleIcon"
							:clearable="true" clearIcon="tabler:x" @click="showFilters = !showFilters" />
					</div>
				</template> -->
				<template #append>
					<EwButton type="secondary" size="md" :loading="false" :label="labels.searchBtn" :clearable="true"
						clearIcon="tabler:x" icon="tabler:search" @click="triggerSearch" />
				</template>
			</EwInput>

			<Transition enter-active-class="transition-all duration-300 ease-out"
				leave-active-class="transition-all duration-300 ease-in" enter-from-class="opacity-0 scale-95"
				enter-to-class="opacity-100 scale-100" leave-from-class="opacity-100 scale-100"
				leave-to-class="opacity-0 scale-95">
				<div v-if=" showFilters "
					class="left-0 right-0 absolute top-[40px] bg-white px-2 pt-2 pb-3 shadow border rounded z-10 transition-all">
					<div class="font-500 flex items-center pb-2 mb-3">
						Filter by
						<EwButton class="ml-auto" size="xs" :loading="false" :label="'Clear Filters'" icon="tabler:x"
							@click="clearFilters" />
					</div>

					<div class="flex flex-wrap gap-3 mb-3">
						<EwSelect class="min-w-[250px] flex-1" size="md" v-model="filters.inputMaterialType"
							:options="cvData?.data.inputMaterialType ?? []" optionValue="identifier" optionLabel="title"
							:placeholder="'Type of input material'" label="Type of input material" :clearable="true"
							clearIcon="tabler:x" :iconsInside="true" @change="filters.inputMaterialType = $event" />
						<EwSelect class="min-w-[250px] flex-1" size="md" v-model="filters.outcomeType"
							:options="cvData?.data.outcomeType ?? []" optionValue="identifier" optionLabel="title"
							:placeholder="'Type of outcome'" label="Type of outcome" :clearable="true"
							clearIcon="tabler:x" />
						<EwMultiSelect class="min-w-[250px] flex-1" v-model="filters.author" label="Author"
							:options="cvData?.data.author ?? []" display="chip" truncate optionValue="identifier"
							optionLabel="title" placeholder="Author" size="sm" :clearable="false" />
						<EwMultiSelect class="min-w-[250px] flex-1" v-model="filters.targetAudience"
							:options="cvData?.data.targetAudience ?? []" display="chip" truncate optionValue="identifier"
							optionLabel="title" placeholder="Target audience" label="Target audience" size="sm"
							:clearable="false" />
					</div>
				</div>
			</Transition>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed, watch, inject, provide } from 'vue'
import type { ListFilters, CVResponse } from '@/types'
import Swal from 'sweetalert2'
import { EwInput, EwMultiSelect, EwSelect, EwButton } from '@arkit/ew-vue-components'
import { CVDataProvided } from '@/types/cvTypes'
import type { configCollectionMode } from '@/types'

import { messages } from '@/assets/language'
import { useAppStore } from '@/stores/app-store'
import FilterGroupedStatus from './FilterGroupedStatus.vue'


// // Props që vijnë nga prindi
// const props = defineProps<{
//   authoringStatusOptions: { identifier: string; title: string }[]
//   publishingStatusOptions: { identifier: string; title: string }[]
//   reviewStatusOptions: { identifier: string; title: string }[]
// }>()

const { currentLng } = useAppStore()

const labels = computed( () => {
	const key = currentLng.value as keyof typeof messages
	return messages[key] ?? {}
} )

const isLoading = defineModel<boolean>( 'loading' )

const cvData = inject( CVDataProvided ) as Ref<CVResponse>
provide( CVDataProvided, cvData )

const props = defineProps<{
  collectionModeData?: configCollectionMode | null
}>();

const filters = defineModel<ListFilters>( {
	default: () => ( {
		search: null,
		author: [],
		outcomeType: [],
		targetAudience: [],
		inputMaterialType: [],
		medicalSpecialties: [],
		studyType: [],
		allStatuses: []
	} )
} )

const showFilters = defineModel<boolean>( 'showFilters', {
	default: true
} )

const emit = defineEmits( ['search', 'clear-filters'] )


const triggerSearch = async () => {
  const searchTerm = filters.value.search ?? ''
  if (searchTerm && searchTerm.length < 3) {
    await Swal.fire({
      icon: 'warning',
		title: 'Search Term Too Short',
		text: 'Please enter a minimum of 3 characters to perform a search.',
      confirmButtonText: 'OK',
      confirmButtonColor: '#3085d6'
    })
    return
  }

  isLoading.value = true

  try {
    // presim që prindi të kthejë një promise
    await emit('search', filters.value)
  } finally {
    isLoading.value = false
  }
}

const clearFilters = () => {
	emit( 'clear-filters' )
}

watch( () => filters.value.search, ( newVal ) => {
	if ( !newVal ) {
		emit( 'search', filters.value )
	}
} )
watch(() => filters.value.allStatuses, () => {
  triggerSearch()
})



</script>

<style>

.ew-multiselect-label.ew-multiselect-truncated {
	padding-top: 0.5rem;
	padding-bottom: 0.5rem;
	padding-left: 0.75rem;
	padding-right: 0.75rem;
}

.p-multiselect-label-container.ew-multiselect-input.ew-input-sm.ew-input-sm {
	padding: 0 !important;
}
</style>
